import React from 'react';
import Proptypes from 'prop-types';
import Paper from 'material-ui/Paper';

const EmptyBox = ({ position }) => (
  <div style={{
      display: 'flex',
      width: '100%',
      height: '100%',
      justifyContent: 'space-around',
      }}
  >
    <h2>{`BOX * ${position}`}</h2>
  </div>
);
EmptyBox.propTypes = {
  position: Proptypes.string,
};
EmptyBox.defaultProps = {
  position: 'X',
};

const topGrow = 7;
const topPerc = '70%';
const bottomGrow = 3;
const bottomPerc = '30%';

const styles = {
  container: {
    display: 'flex',
    height: '100vh',
    flexDirection: 'column',
    // borderStyle: 'dashed',
  },
  top: {
    display: 'flex',
    // position: 'relative',
    flexGrow: topGrow,
    // height: topPerc,
    maxHeight: topPerc,
    // justifyContent: 'center',
    alignItems: 'normal',
    // margin: '10px 10px 10px 10px',
    justifyContent: 'space-around',
    // padding: '10px',
    // borderStyle: 'dashed',

    /* extra */
    // background: 'cyan',
  },
  bottom: {
    display: 'flex',
    flexGrow: bottomGrow,
    // height: bottomPerc,
    maxHeight: bottomPerc,
    justifyContent: 'space-around',
    alignItems: 'normal',
    margin: '10px 10px 10px 10px',
    overflow: 'hidden',
    // paddingTop: '10px',
    // borderStyle: 'dashed',

    /* extra */
    // background: 'cadetblue',
    // margin: '10px',

  },
  bottomBox: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-around',
    alignItems: 'normal',
    alignSelf: 'normal',
    maxWidth: '33.3333%',
    // maxHeight: '30%',
    // height: '100%',
    overflow: 'hidden',
    // marginTop: '10px',
    // borderStyle: 'dashed',
    // background: '#2C216C',
    marginRight: '2px',
  },
  bottomBoxC: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-around',
    alignItems: 'normal',
    alignSelf: 'normal',
    maxWidth: '33.3333%',
    // maxHeight: '100%',
    // height: '100%',

    marginLeft: '2px',
    marginRight: '2px',

    // marginTop: '10px',
    // borderStyle: 'dashed',
    // background: '#2C216C',
  },
  bottomBoxD: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-around',
    alignItems: 'normal',
    alignSelf: 'normal',
    maxWidth: '33.3333%',
    // maxHeight: '100%',
    // height: '100%',

    marginLeft: '2px',
    // marginRight: '10px',

    // marginTop: '10px',
    // borderStyle: 'dashed',
    // background: '#2C216C',
  },
};

const TemplateComp = (props) => {
  const {
    boxA, boxB, boxC, boxD,
  } = props;
  // console.log('TemplateComp', props);
  return (
    <div style={styles.container} >
      <Paper zDepth={5} style={styles.top}>
        {boxA}
      </Paper>
      <div style={styles.bottom}>
        <Paper zDepth={5} style={styles.bottomBox}>
          {boxB}
        </Paper>
        <Paper zDepth={5} style={styles.bottomBoxC}>
          {boxC}
        </Paper>
        <Paper zDepth={5} style={styles.bottomBoxD}>
          {boxD}
        </Paper>
      </div>
    </div>
  );
};
TemplateComp.propTypes = {
  boxA: Proptypes.object,
  boxB: Proptypes.object,
  boxC: Proptypes.object,
  boxD: Proptypes.object,
};
TemplateComp.defaultProps = {
  boxA: {},
  boxB: {},
  boxC: {},
  boxD: {},
};

const gridStyleFromCoords = ({ topLeft = '1:1', bottomRight = '1:1' }) => {
  const gridColumnStart = `${topLeft}:1:1`.split(':')[0];
  const gridRowStart = `${topLeft}:1:1`.split(':')[1];
  const gridColumnEnd = `${bottomRight}:1:1`.split(':')[0];
  const gridRowEnd = `${bottomRight}:1:1`.split(':')[1];
  return {
    gridColumnStart,
    gridRowStart,
    gridColumnEnd,
    gridRowEnd,
  }
};
const gridTemplate = (props) => {
  const {
    boxA, boxB, boxC, boxD, layout,
  } = props;

  console.log('::::: layout', layout);

  const layoutParams = new URLSearchParams(layout);
  console.log(':::: screen ', layoutParams.get('grid'));
  console.log(':::: box a ', layoutParams.get('a'));
  console.log(':::: box b ', layoutParams.get('b'));
  console.log(':::: box c ', layoutParams.get('c'));
  console.log(':::: box d ', layoutParams.get('d'));

  const grid = `${(layoutParams.get('grid') || '12:10')}`.split(':');  
  console.log(':::::: grid', layoutParams.get('grid'), grid)
  // 1:1,1:5
  const coordsA = `${(layoutParams.get('a') || '1:1,13:8')}`.split(',');
  const coordsB = `${(layoutParams.get('b') || '1:8,5:11')}`.split(',');
  const coordsC = `${(layoutParams.get('c') || '5:8,9:11')}`.split(',');
  const coordsD = `${(layoutParams.get('d') || '9:8,13:11')}`.split(',');

  const columns = grid[0];
  const rows = grid[1];
  const gridStyle = {
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gridTemplateRows: `repeat(${rows}, 1fr)`,
    height: '100vh',
    minHeight: '100vh',
    width: '100vw',
    minWidth: '100vw',
  };

  return (
    <div className="grid h-full min-h-full bg-black" style={gridStyle}>
      { (layoutParams.get('a') || !layoutParams.get('grid')) &&
        <div style={gridStyleFromCoords({ topLeft: coordsA[0], bottomRight: coordsA[1] })}>
          <div className="h-full max-h-full">
            {boxA}
          </div>
        </div>
      }
      { (layoutParams.get('b') || !layoutParams.get('grid')) &&
        <div style={gridStyleFromCoords({ topLeft: coordsB[0], bottomRight: coordsB[1] })}>
          <div className="h-full max-h-full">
            {boxB}
          </div>
        </div>
      }
      { (layoutParams.get('c') || !layoutParams.get('grid')) &&
        <div style={gridStyleFromCoords({ topLeft: coordsC[0], bottomRight: coordsC[1] })}>
          <div className="h-full max-h-full">
            {boxC}
          </div>
        </div>
      }
      { (layoutParams.get('d') || !layoutParams.get('grid')) &&
        <div style={gridStyleFromCoords({ topLeft: coordsD[0], bottomRight: coordsD[1] })}>
          <div className="h-full max-h-full">
            {boxD}
          </div>
        </div>
      }
    </div>
  );
};

const Template2 = (props) => {
  const {
    boxA, boxB, boxC, boxD,
  } = props;
  console.log(props);
  return (
    <div className="flex flex-col w-full h-full max-w-full max-h-full overflow-x-hidden overflow-y-hidden">
      <div className="" style={{ height: '70vh', maxHeight: '70vh' }}>
        <div className="h-full max-h-full">
          {boxA}
        </div>
      </div>
      <div className="flex flex-row" style={{ height: '30vh', maxHeight: '30vh' }} >
        <div className="w-1/3">
          {boxB}
        </div>
        <div className="w-1/3">
          {boxC}
        </div>
        <div className="w-1/3">
          {boxD}
        </div>
      </div>
    </div>
  );
}

export {
  EmptyBox,
  gridTemplate as Template1,
  // Template2 as Template1,
  // TemplateComp as Template1,
};




// WEBPACK FOOTER //
// ./src/components/templates/index.js